import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2ZM10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.768 8.613c0-1.231 1.011-2.208 2.232-2.208 1.222 0 2.232.979 2.232 2.21 0 .976-.651 1.486-1.071 1.765-.174.115-.289.21-.361.306-.06.08-.1.172-.1.318v.188a.7.7 0 1 1-1.4 0v-.188c0-.99.657-1.506 1.087-1.79.17-.113.279-.205.348-.297a.464.464 0 0 0 .097-.303.82.82 0 0 0-.832-.809.82.82 0 0 0-.832.808.7.7 0 1 1-1.4 0ZM9.198 12.938a.784.784 0 1 1 1.568-.01.784.784 0 0 1-1.568.01Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
